/**
 * Toggle between content "events" and "articles" on
 * the single organisation page
 *
 * @author Matt Haynes
 * @package Joi Polloi
 *
 */

const singleOrganisationPageToggle = () => {
    const buttons = document.querySelectorAll('.orgToggle');
    const posts = document.querySelectorAll('.orgPosts');
    if (!buttons || !posts) return;

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const { listingtoshow } = button.dataset;

            buttons.forEach(buttonX => {
                if (button === buttonX) {
                    button.classList.add('active');
                } else {
                    buttonX.classList.remove('active');
                }
            });

            posts.forEach(post => {
                const { listingname } = post.dataset;

                if (listingtoshow === listingname) {
                    post.classList.add('showing');
                } else {
                    post.classList.remove('showing');
                }
            });
        });
    });
};

export default singleOrganisationPageToggle;
